async function uploadFile(fileOrBlob, resource_owner = {}) {
    console.log("fileOrBlob", fileOrBlob);
    const formData = new FormData();
    formData.append("file", fileOrBlob);

    for (const key in resource_owner) {
        if (resource_owner.hasOwnProperty(key)) {
            // Check if the property is directly on the object and not inherited
            formData.append(key, resource_owner[key]);
        }
    }

    const options = {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
            console.log("loaded", progressEvent.loaded);
            console.log(
                "progress",
                parseInt(
                    Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total,
                    ),
                ),
            );
        },
    };

    try {
        const { data } = await axios.post("/upload", formData, options);
        return data; //return whole data
    } catch (error) {
        //alert("File upload has failed pleae try again");
        throw error;
    }
}

function dataURItoBlob(dataURI) {
    // convert base64 to raw binary data held in a string
    var byteString = atob(dataURI.split(",")[1]);

    // separate out the mime component
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    // write the bytes of the string to an ArrayBuffer
    var arrayBuffer = new ArrayBuffer(byteString.length);
    var _ia = new Uint8Array(arrayBuffer);
    for (var i = 0; i < byteString.length; i++) {
        _ia[i] = byteString.charCodeAt(i);
    }

    var dataView = new DataView(arrayBuffer);
    var blob = new Blob([dataView], { type: mimeString });
    return blob;
}

export { uploadFile };
